import React from 'react';
import { LinearProgress, Grid } from '@mui/material';

export const LineLoader = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <LinearProgress color="secondary" />
      </Grid>
    </Grid>
  );
};
